export function TimelineActor({name}:{name?:string|null}){
  const actor=name?.trim()||"Usuário do SGQ",parts=actor.split(/\s+/).filter(Boolean),initials=`${parts[0]?.[0]||"U"}${parts.length>1?parts.at(-1)?.[0]||"":""}`.toLocaleUpperCase("pt-BR");
  return <small className="timeline-actor"><span className="avatar timeline-actor-avatar" aria-hidden="true">{initials}</span><span>Por {actor}</span></small>;
}
